// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3038":"3502385b7b017b2c","3608":"3502385b7b017b2c"}[chunkId] + ".css";
};